"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePR = exports.revokePR = exports.getPRReducer = void 0;
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var doesObjHaveUndefinedValues_1 = __importDefault(require("common/utils/doesObjHaveUndefinedValues"));
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var app_1 = __importStar(require("firebase/app"));
var lodash_1 = require("lodash");
var set_1 = __importDefault(require("lodash/fp/set"));
var moment_1 = __importDefault(require("moment"));
var sendApprovalNotification_1 = require("portal/utils/sendApprovalNotification");
var SendNotification_1 = require("portal/utils/SendNotification");
var ADD_ROW = 'addRow';
var getPRReducer = function (router, t) { return function (state, action) {
    var _a, _b, _c, _d, _e;
    var userId = (_b = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : '';
    var match = router.match;
    var PRId = match.params.PRId;
    switch (action.type) {
        case 'init':
            return action.payload;
        case 'update':
            if (action.payload.path === 'PRData.date') {
                var isBefore = (0, moment_1.default)(action.payload.newValue).isBefore((_c = state.POData.PODate) === null || _c === void 0 ? void 0 : _c.toDate());
                if (isBefore) {
                    antd_1.message.error('PR Date can not be before PO Date');
                }
                var newDate = isBefore ? (_e = (_d = state.POData) === null || _d === void 0 ? void 0 : _d.PODate) === null || _e === void 0 ? void 0 : _e.toDate() : action.payload.newValue;
                return (0, set_1.default)(action.payload.path, newDate, state);
            }
            return (0, set_1.default)(action.payload.path, action.payload.newValue, state);
        case 'buttonClick':
            switch (action.data.action) {
                case ADD_ROW: {
                    var PRItem_1 = newPRItem(PRId);
                    return __assign(__assign({}, state), { PRItems: __spreadArray(__spreadArray([], state.PRItems, true), [PRItem_1], false) });
                }
                case 'Approve': {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    transaction.set(collectionsRef_1.approvalsRef.doc(), {
                                        approvedAt: new Date(),
                                        createdAt: new Date(),
                                        updatedAt: new Date(),
                                        userId: userId,
                                        formId: state.PRId,
                                        formType: 'payment-request',
                                        approvalType: action.data.payload,
                                        signatureURL: (_b = (_a = usersList_1.globalUsersData[userId]) === null || _a === void 0 ? void 0 : _a.signatureURL) !== null && _b !== void 0 ? _b : ""
                                    });
                                    return [4 /*yield*/, checkIfAllApproved(state, action.data.payload, userId, state.PRId, state.PRData.orderId, transaction)];
                                case 1:
                                    _c.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t('alerts.success'));
                        window.location.reload();
                    });
                    break;
                }
                case 'delete': {
                    var index_1 = action.data.payload;
                    app_1.default.firestore().runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            transaction.delete(collectionsRef_1.PRItemsRef.doc((_a = state.PRItems[index_1]) === null || _a === void 0 ? void 0 : _a.id));
                            return [2 /*return*/];
                        });
                    }); });
                    return __assign(__assign({}, state), { PRItems: __spreadArray(__spreadArray([], state.PRItems.slice(0, index_1), true), state.PRItems.slice(index_1 + 1), true) });
                }
                case 'Save': {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            transaction.update(collectionsRef_1.PRsRef.doc(PRId), (0, removeUndefined_1.default)(getPRDataFromState(state)));
                            state.PRItems.map(function (item, index) {
                                var data = createPRItem(PRId, item);
                                transaction.set(collectionsRef_1.PRItemsRef.doc(item.id), (0, removeUndefined_1.default)(__assign(__assign({}, data), { index: index })));
                            });
                            return [2 /*return*/];
                        });
                    }); })
                        .then(function () {
                        antd_1.message.success(t('alerts.success'));
                    })
                        .catch(function (error) {
                        console.log('error', error);
                        antd_1.message.error(error);
                    });
                    break;
                }
                case 'Cancel': {
                    collectionsRef_1.PRsRef.doc(state.PRId)
                        .update({ status: 'cancelled' })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                        officeId: state.PRData.destinationOffice,
                                        projectId: (_a = state.PRData) === null || _a === void 0 ? void 0 : _a.projectId,
                                        amount: 0,
                                        docId: PRId,
                                        docType: 'payment-request',
                                        ref: state.PRData.PONumber,
                                        userId: userId,
                                        docDesc: '',
                                        action: 'cancelled',
                                    }).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                                        officeId: state.PRData.destinationOffice,
                                                        projectId: state.PRData.projectId,
                                                        docType: 'payment-request',
                                                        docId: state.PRId,
                                                        ref: (_a = state.PRData.PRNumber) !== null && _a !== void 0 ? _a : '',
                                                        docDesc: state.PRData.purposeOfPayment,
                                                        action: 'cancelled',
                                                    })];
                                                case 1:
                                                    _b.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, antd_1.message.success(t('alerts.success'))];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }).then(function () {
                                        window.location.reload();
                                    })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                }
                case 'Publish': {
                    var isInvalid_1 = false;
                    var PRData_1 = getPRDataFromState(state);
                    // if (doesObjHaveUndefinedValues(PRData)) {
                    //     isInvalid = true
                    //     message.error(t('alerts.invalidFormMsg'))
                    //     return { ...state, triedSubmitting: true }
                    // }
                    state.PRItems.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            data = createPRItem(PRId, item);
                            if ((0, doesObjHaveUndefinedValues_1.default)(data)) {
                                isInvalid_1 = true;
                                antd_1.message.error(t('alerts.invalidFormMsg'));
                                return [2 /*return*/, __assign(__assign({}, state), { triedSubmitting: true })];
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    var totalEquivalentAmountInUSD_1 = (0, lodash_1.sumBy)(state.PRItems, function (item) { return item.transactionAmount / item.exchangeRate; });
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    transaction.update(collectionsRef_1.PRsRef.doc(state.PRId), PRData_1);
                                    state.PRItems.map(function (item, index) {
                                        var data = createPRItem(PRId, item);
                                        if ((0, doesObjHaveUndefinedValues_1.default)(data)) {
                                            isInvalid_1 = true;
                                            return __assign(__assign({}, state.PRItems), { triedSubmitting: true });
                                        }
                                        else {
                                            transaction.set(collectionsRef_1.PRItemsRef.doc(item.id), data);
                                        }
                                    });
                                    if (!(isInvalid_1 === false)) return [3 /*break*/, 2];
                                    transaction.update(collectionsRef_1.PRsRef.doc(state.PRId), {
                                        status: 'pendingPrRequestedByApproval',
                                        totalEquivalentAmountInUSD: totalEquivalentAmountInUSD_1,
                                        requestedAt: new Date(),
                                        requestedBy: (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.uid,
                                    });
                                    return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                                            officeId: state.PRData.destinationOffice,
                                            approval: 'PRRequestedByApproval',
                                            projectId: (_b = state.PRData) === null || _b === void 0 ? void 0 : _b.projectId,
                                            amount: totalEquivalentAmountInUSD_1,
                                            docId: PRId,
                                            docType: 'payment-request',
                                            ref: state.PRData.PONumber,
                                            userId: userId,
                                            docDesc: state.PRData.purposeOfPayment,
                                            action: 'approvalPending',
                                        })];
                                case 1:
                                    _c.sent();
                                    _c.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (isInvalid_1 === false) {
                                antd_1.message.success(t('alerts.success'));
                                window.location.reload();
                            }
                            else {
                                antd_1.message.error(t('alerts.invalidFormMsg'));
                            }
                            return [2 /*return*/];
                        });
                    }); })
                        .catch(function (e) {
                        console.error(e);
                        antd_1.message.error(t('alerts.error'));
                    });
                    break;
                }
                case 'Revoke': {
                    app_1.default
                        .firestore()
                        .runTransaction(function (transaction) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, (0, exports.revokePR)(state.PRId, state.PRData.orderId, transaction)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .then(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                                        officeId: state.PRData.destinationOffice,
                                        projectId: state.PRData.projectId,
                                        docType: 'payment-request',
                                        docId: state.PRId,
                                        ref: (_a = state.PRData.PRNumber) !== null && _a !== void 0 ? _a : '',
                                        docDesc: state.PRData.purposeOfPayment,
                                        action: 'revoked',
                                    })];
                                case 1:
                                    _b.sent();
                                    antd_1.message.success(t('alerts.success'));
                                    window.location.reload();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        console.log(e);
                        antd_1.message.error(t('alerts.error'));
                    });
                    break;
                }
            }
    }
    return state;
}; };
exports.getPRReducer = getPRReducer;
var getPRDataFromState = function (state) {
    // const totalSYR = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'SYR' ? item.transactionAmount : 0
    // )
    // const totalEURO = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'EUR' ? item.transactionAmount : 0
    // )
    // const totalUSD = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'USD' ? item.transactionAmount : 0
    // )
    // const totalTL = sumBy(state.PRItems, item =>
    //     globalCurrenciesData[item.transactionCurrencyId]?.name === 'TRY' ? item.transactionAmount : 0
    // )
    // const totalEquivalentAmountInUSD = sumBy(state?.PRItems, item => item?.USDAmountOfTransaction)
    // console.log({ total: totalEquivalentAmountInUSD })
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    return __assign(__assign({}, state.PRData), { date: (_b = (_a = state.PRData.date) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : null, createdAt: (_c = new Date()) !== null && _c !== void 0 ? _c : null, invoiceNumber: (_d = state.PRData.invoiceNumber) !== null && _d !== void 0 ? _d : '', to: (_e = state.PRData.to) !== null && _e !== void 0 ? _e : '', from: (_f = state.PRData.from) !== null && _f !== void 0 ? _f : '', totalAmountSYR: (_g = state.PRData.totalAmountSYR) !== null && _g !== void 0 ? _g : '', totalAmountTL: (_h = state.PRData.totalAmountTL) !== null && _h !== void 0 ? _h : '', totalAmountEURO: (_j = state.PRData.totalAmountEURO) !== null && _j !== void 0 ? _j : '', totalAmountUSD: (_k = state.PRData.totalAmountUSD) !== null && _k !== void 0 ? _k : '', totalAmountSpellSYR: (_l = state.PRData.totalAmountSpellSYR) !== null && _l !== void 0 ? _l : '', totalAmountSpellTL: (_m = state.PRData.totalAmountSpellTL) !== null && _m !== void 0 ? _m : '', totalAmountSpellEURO: (_o = state.PRData.totalAmountSpellEURO) !== null && _o !== void 0 ? _o : '', totalAmountSpellUSD: (_p = state.PRData.totalAmountSpellUSD) !== null && _p !== void 0 ? _p : '', totalEquivalentAmountInUSD: (_q = (0, lodash_1.sumBy)(state.PRItems, function (item) { return item.transactionAmount / item.exchangeRate; })) !== null && _q !== void 0 ? _q : '', totalEquivalentAmountInUSDSpell: (_r = state.PRData.totalEquivalentAmountInUSDSpell) !== null && _r !== void 0 ? _r : '', purposeOfPayment: (_s = state.PRData.purposeOfPayment) !== null && _s !== void 0 ? _s : '', paymentModeRequested: (_t = state.PRData.paymentModeRequested) !== null && _t !== void 0 ? _t : '', destinationCountry: (_u = state.PRData.destinationCountry) !== null && _u !== void 0 ? _u : '', destinationOffice: (_v = state.PRData.destinationOffice) !== null && _v !== void 0 ? _v : '', preparedByLogistics: (_w = state.PRData.preparedByLogistics) !== null && _w !== void 0 ? _w : '', note: (_x = state.PRData.note) !== null && _x !== void 0 ? _x : '', dueDate: (_z = (_y = state.PRData.dueDate) === null || _y === void 0 ? void 0 : _y.toDate()) !== null && _z !== void 0 ? _z : null, supplierBankName: (_0 = state.PRData.supplierBankName) !== null && _0 !== void 0 ? _0 : '', supplierBranch: (_1 = state.PRData.supplierBranch) !== null && _1 !== void 0 ? _1 : '', supplierAccountName: (_2 = state.PRData.supplierAccountName) !== null && _2 !== void 0 ? _2 : '', supplierIban: (_3 = state.PRData.supplierIban) !== null && _3 !== void 0 ? _3 : '' });
};
var createPRItem = function (PRId, item) {
    return {
        PRId: PRId,
        // itemNo: item.itemNo,
        paymentDestination: item.paymentDestination,
        transactionCurrencyId: item.transactionCurrencyId,
        transactionAmount: item.transactionAmount,
        exchangeRate: item.exchangeRate,
        USDAmountOfTransaction: item.transactionAmount / item.exchangeRate,
        projectCode: item.projectCode,
        budgetLine: item.budgetLine,
    };
};
function newPRItem(PRId) {
    return {
        id: collectionsRef_1.PRItemsRef.doc().id,
        PRId: PRId,
        paymentDestination: '',
        transactionCurrency: '',
        transactionAmount: 0,
        exchangeRate: 0,
        USDAmountOfTransaction: 0,
    };
}
function checkIfAllApproved(state, approvalType, userId, PRId, orderId, transaction) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var waitingFor, totalEquivalentAmountInUSD;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    totalEquivalentAmountInUSD = (0, lodash_1.sumBy)(state.PRItems, function (item) { return item.USDAmountOfTransaction; });
                    if (!(approvalType === 'authorizedBy')) return [3 /*break*/, 2];
                    transaction.update(collectionsRef_1.PRsRef.doc(PRId), { status: 'approved' });
                    return [4 /*yield*/, (0, SendNotification_1.sendNotification)({
                            officeId: state.PRData.destinationOffice,
                            projectId: state.PRData.projectId,
                            docType: 'payment-request',
                            docId: state.PRId,
                            ref: (_a = state.PRData.PRNumber) !== null && _a !== void 0 ? _a : '',
                            docDesc: state.PRData.purposeOfPayment,
                            action: 'approved',
                        })];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
                case 2:
                    transaction.update(collectionsRef_1.PRsRef.doc(PRId), { status: 'pendingPrAuthorizedByApproval' });
                    waitingFor = 'PRAuthorizedByApproval';
                    _c.label = 3;
                case 3: return [4 /*yield*/, (0, sendApprovalNotification_1.sendApprovalNotification)({
                        officeId: state.PRData.destinationOffice,
                        approval: waitingFor,
                        projectId: (_b = state.PRData) === null || _b === void 0 ? void 0 : _b.projectId,
                        amount: totalEquivalentAmountInUSD,
                        docId: PRId,
                        docType: 'payment-request',
                        ref: state.PRData.PONumber,
                        userId: state.PRData.requestedBy,
                        docDesc: state.PRData.purposeOfPayment,
                        action: 'approvalPending',
                    })];
                case 4:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var revokePR = function (PRId, orderId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                transaction.update(collectionsRef_1.PRsRef.doc(PRId), {
                    status: 'draft',
                    requestedAt: app_1.default.firestore.FieldValue.delete(),
                    requestedBy: app_1.default.firestore.FieldValue.delete(),
                });
                transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: 'postPOs' });
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where('formId', '==', PRId).get()];
            case 1:
                (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.docs.map(function (x) { return transaction.delete(x.ref); });
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where('docId', '==', PRId).get()];
            case 2:
                (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.docs.map(function (x) { return transaction.delete(x.ref); });
                return [2 /*return*/];
        }
    });
}); };
exports.revokePR = revokePR;
var deletePR = function (PRId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data, _a, _b;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.PRsRef.doc(PRId).get()];
            case 1:
                data = (_e.sent()).data();
                if (data.status === 'singedAndArchived' || data.status === 'completed') {
                    throw new Error("you cannot delete singed form");
                }
                if (!(data.status === 'pendingApprovals' || data.status === 'approved')) return [3 /*break*/, 6];
                transaction.delete(collectionsRef_1.PRsRef.doc(PRId));
                _b = (_a = Promise).all;
                return [4 /*yield*/, collectionsRef_1.PRItemsRef.where('PRId', '==', PRId).get()];
            case 2: return [4 /*yield*/, _b.apply(_a, [(_e.sent()).docs.map(function (x) { return transaction.delete(x.ref); })])];
            case 3:
                _e.sent();
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where('formId', '==', PRId).get()];
            case 4:
                (_c = (_e.sent())) === null || _c === void 0 ? void 0 : _c.docs.map(function (x) { return transaction.delete(x.ref); });
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where('docId', '==', PRId).get()];
            case 5:
                (_d = (_e.sent())) === null || _d === void 0 ? void 0 : _d.docs.map(function (x) { return transaction.delete(x.ref); });
                _e.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.deletePR = deletePR;
